import { render, staticRenderFns } from "./InputSelect2.vue?vue&type=template&id=97f534ae&"
import script from "./InputSelect2.vue?vue&type=script&lang=js&"
export * from "./InputSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports